// src/features/Setting/Melting_Requests/api/meltingRequestApi.js
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import apiClient from "lib/api-client";
import { formatDateAndTime } from "utils/formatDateAndTime";

// Constants



// Format API response data
export const MeltingRequestData = (apiData) => {
  return apiData.map((item) => ({
    id: item._id || item.id,
    userName: item.createMeltingRequestUserRef || "-",
    dateTime: formatDateAndTime(item.createdAt),
    meltingRequestId: item.formatMeltingRequestId,
    quantity: Array.isArray(item.meltingStockJewelCount) ? item.meltingStockJewelCount.length : 0,
    diamondWt: item.totalDiaWt ? `${item.totalDiaWt} Ct` : "0 Ct",
    goldWt: item.totalNetWt ? `${item.totalNetWt} g` : "0 g",
    status: item.statusTimeline || "Completed",
    remark: item.remark || "No remark",
    jewelCodes: Array.isArray(item.meltingStockJewelCode) ? item.meltingStockJewelCode : [],
    rawData: item
  }));
};

// Main API function to fetch melting requests
const fetchMeltingRequests = async ({
  pageParam = 1,
  limit = 16,
  sortBy,
  order,
  searchBy,
  status
}) => {
  const res = await apiClient.post("/api/v1/melting_request/getAll", {
    page: pageParam,
    limit,
    sortBy,
    order,
    searchBy,
    status
  });

  return res?.data;
};

export const useMeltingRequestInfinite = ({

  limit = 16,
  sortBy,
  order,
  searchBy,
  status }) => {
  return useInfiniteQuery({
    queryKey: ["melting-requests", limit, sortBy, order, searchBy, status],

    queryFn: ({ pageParam }) =>
      fetchMeltingRequests({
        pageParam,
        limit,
        sortBy,
        order,
        searchBy,
        status,
      }),

    getNextPageParam: (lastPage) => {
      // console.log("lasstttt", lastPage);
      const { currentPage, totalPages } = lastPage;
      return currentPage < totalPages ? currentPage + 1 : undefined;
    }
  });
};





// Fetch single melting request by ID
const fetchMeltingRequestDetails = async (payload) => {

  const res = await apiClient.post(
    "/api/v1/melting_request/getStockAccDegins",
    payload
  );

  return res.data?.result;
};

export const useMeltingRequestDetail = (payload) => {
  return useQuery({
    queryKey: ["melting-request-detail", payload],
    queryFn: () => fetchMeltingRequestDetails(payload),
    enabled: !!payload,
    staleTime: 5 * 60 * 1000,
  });
};


// Update melting request status


export const updateMeltingRequestStatus = async (payload) => {
  const res = await apiClient.put(
    "/api/v1/melting_request/updateMeltingReq",
    payload
  );
  console.log("Payload Data===>", payload);

  return res.data;
};

export const reopenMeltingRequestStatus = async (id) => {
  const res = await apiClient.put(
    `/api/v1/melting_request/reopenStatus/${id}`
  );

  return res.data;
};


// Delete melting request
export const updateMeltingRequest = async (payload) => {
  try {
    const response = await apiClient.put(
      `/api/v1/melting_request/updateMeltingReq`,
      payload
    );

    if (response.status !== 200) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.data;
  } catch (error) {
    console.error(`Error updating melting request:`, error);
    throw error;
  }
};

export default {
  fetchMeltingRequests,
  fetchMeltingRequestDetails,
  updateMeltingRequestStatus,
  updateMeltingRequest,
  MeltingRequestData
};